/* eslint-disable @typescript-eslint/no-explicit-any */
// Exchange Control: el resultado de cada tarea e integración del cliente (iRegistryImportSOs):
// qué se procesó, cuándo, si funcionó y qué se mandó o recibió. Lo ve el cliente (solo su empresa) y el admin (todas).
// Kit nuevo (components/ihub) con el tema de cada cliente (brand.theme del login).
// Los filtros se piden de nuevo al cambiar el rango y con Refresh, así nunca quedan vacíos con datos en la tabla.
// Todas las opciones salen de las filas del rango. Cada filtro acepta varios valores (OR); entre filtros, AND.
// Una fila es el estado de una operación; el detalle muestra su historia. Stop corta la espera de una consulta larga.
import React, { useCallback, useEffect, useRef, useState } from 'react';
import moment from 'moment';
import PageTitle from '../../components/Common/MetaTagsHelper/metaTagsHelper';
import { getNameClient } from '../../helpers/nameClient';
import usePageTitle from '../../common/hooks/usePageTitle';
import {
  getExchangeControl,
  countExchangeControl,
  getExchangeControlOptions,
  getExchangeControlHistory,
  detenerConsultas,
  esAdminHub,
} from '../../helpers/exchangeControl_helper';
import {
  Page,
  Card,
  Field,
  DateRange,
  Segmented,
  Stat,
  Badge,
  Button,
  DataTable,
  Drawer,
  MetaGrid,
  Alert,
  EmptyState,
} from '../../components/ihub';
import { ExportMenu, traerTodo } from '../../components/ihub/export';
import { MultiSelectField } from '../../components/ihub/multiselect';

const F = 'YYYY-MM-DD';
const VACIO = () => ({
  from: moment().subtract(6, 'days').format(F),
  to: moment().format(F),
  reference: [] as string[],
  identificator: [] as string[],
  entity: [] as string[],
  taskId: [] as string[],
  clientId: [] as string[],
  status: '',
});
const INTEGRACIONES: any = { 'SH-OceanTracking': 'Ocean Tracking' };
const integracion = (i: any) => (i ? INTEGRACIONES[i] || i : '-');
const fecha = (s: any) => {
  if (s === null || s === undefined || s === '') return null;
  const m = /^\d+$/.test(String(s)) ? moment(Number(s)) : moment(s);
  return m.isValid() ? m : null;
};
const dia = (s: any) => (fecha(s) ? (fecha(s) as any).format('MMM D, YYYY') : '');
const hora = (s: any) => (fecha(s) ? (fecha(s) as any).format('HH:mm:ss') : '');
const completa = (s: any) => (fecha(s) ? (fecha(s) as any).format('ddd, MMM D YYYY · HH:mm:ss') : '');
const hace = (s: any) => (fecha(s) ? (fecha(s) as any).fromNow() : '');
const corto = (s: any, n = 160) => {
  const t = String(s || '').replace(/\s+/g, ' ').trim();
  return t.length > n ? `${t.slice(0, n)}…` : t;
};
const ok = (r: any) => r?.status === 'Processed';
// Pasos de la historia: etiqueta y color por tipo de paso.
const PASOS: any = {
  SUBSCRIBED: 'Tracking',
  STOPPED: 'Stopped',
  SOURCE_OUTDATED: 'Magaya ETA',
  ETA_CHANGED: 'ETA changed',
  DEPARTED: 'Departed',
  ARRIVED: 'Arrived',
  TRANSSHIPMENT_STUCK: 'Transshipment',
  DAILY_SUMMARY: 'Daily summary',
  ERROR: 'Error',
};
const resuelto = (h: any) => /^(.* · )?(Resuelto|Resolved)/.test(String(h?.message || ''));
const pasoTono = (h: any) => {
  if (Number(h?.status) === 0) return 'danger';
  if (resuelto(h)) return 'success';
  if (h?.action === 'SOURCE_OUTDATED' || h?.action === 'TRANSSHIPMENT_STUCK') return 'warning';
  if (h?.action === 'STOPPED') return 'neutral';
  return 'info';
};
const pasoEtiqueta = (h: any) => (Number(h?.status) === 0 ? 'Error' : resuelto(h) ? 'Resolved' : PASOS[h?.action] || h?.action || 'Update');
// JSON bonito si se puede, texto tal cual si no (XML incluido).
const legible = (v: any) => {
  if (v === null || v === undefined) return '';
  const t = String(v).trim();
  if (!t) return '';
  try {
    return JSON.stringify(JSON.parse(t), null, 2);
  } catch (e) {
    return t;
  }
};

export const SummaryImport = (props: any) => {
  const admin = esAdminHub();
  const titulo = String(usePageTitle(props.location.pathname) || '').replace(/-/g, ' ') || 'Exchange Control';
  const [filters, setFilters] = useState<any>(VACIO);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [sort, setSort] = useState<any>({ key: 'createdAt', dir: 'DESC' });
  const [data, setData] = useState<{ listData: any[]; CountItems: number }>({ listData: [], CountItems: 0 });
  const [stats, setStats] = useState<any>(null);
  const [opciones, setOpciones] = useState<any>({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [fila, setFila] = useState<any>(null);
  const [historia, setHistoria] = useState<any[] | null>(null);
  const [copiado, setCopiado] = useState('');
  const [recarga, setRecarga] = useState(0);
  const abierta = useRef<any>(null);

  const order = `{'${sort.key}' : '${sort.dir}'}`;
  const poner = (patch: any) => {
    setFilters((f: any) => ({ ...f, ...patch }));
    setPage(1);
  };
  const limpiar = () => {
    setFilters(VACIO());
    setPage(1);
  };
  const sucio = JSON.stringify(filters) !== JSON.stringify(VACIO());
  const ops = (k: string) => opciones[k] || [];
  const nombreCliente = (id: any) => {
    const c = ops('clientId').find((x: any) => String(x.value) === String(id));
    return c ? c.label.replace(/ · #\d+$/, '') : `Client ${id}`;
  };

  // Opciones de los filtros: lo que existe en el rango (y en los clientes elegidos, si es admin).
  // Se piden otra vez con Refresh y cuando cambia el total (llegaron filas nuevas).
  const clientesKey = JSON.stringify(filters.clientId);
  useEffect(() => {
    let vivo = true;
    getExchangeControlOptions({ from: filters.from, to: filters.to, clientIds: JSON.parse(clientesKey) })
      .then((o: any) => vivo && setOpciones(o || {}))
      .catch(() => null);
    return () => {
      vivo = false;
    };
  }, [filters.from, filters.to, clientesKey, recarga, data.CountItems]);

  // Lista
  useEffect(() => {
    let vivo = true;
    setLoading(true);
    setError('');
    getExchangeControl({ pagination: { sizePerPage: pageSize, page }, filters, order })
      .then((d: any) => vivo && setData(d))
      .catch((e: any) => vivo && !e?.stopped && setError(e?.message || 'Error'))
      .finally(() => vivo && setLoading(false));
    return () => {
      vivo = false;
    };
  }, [filters, page, pageSize, order, recarga]);

  // Métricas del rango (sin el filtro de estado, para que las tarjetas sirvan de filtro rápido)
  const baseKey = JSON.stringify({ ...filters, status: '' });
  useEffect(() => {
    let vivo = true;
    const base = JSON.parse(baseKey);
    Promise.all([countExchangeControl(base), countExchangeControl({ ...base, status: 'Error' }), countExchangeControl({ ...base, status: 'Processed' })])
      .then(([total, errors, processed]) => vivo && setStats({ total, errors, processed }))
      .catch(() => vivo && setStats({}));
    return () => {
      vivo = false;
    };
  }, [baseKey, recarga]);

  const abrir = (row: any) => {
    abierta.current = row.id;
    setFila(row);
    setHistoria(null);
    getExchangeControlHistory(row.id)
      .then((h: any[]) => abierta.current === row.id && setHistoria(h || []))
      .catch(() => abierta.current === row.id && setHistoria([]));
  };
  const cerrar = useCallback(() => {
    abierta.current = null;
    setFila(null);
    setHistoria(null);
  }, []);
  // Stop: deja de esperar la lista y las métricas (el servidor termina su consulta igual).
  const detener = () => {
    detenerConsultas();
    setLoading(false);
    setStats((x: any) => x || {});
  };
  const copiar = (k: string, v: string) => {
    if (navigator.clipboard) navigator.clipboard.writeText(v).catch(() => null);
    setCopiado(k);
    setTimeout(() => setCopiado(''), 1500);
  };

  const columns = [
    {
      key: 'createdAt',
      label: 'Date',
      sortable: true,
      width: 140,
      render: (r: any) => (
        <>
          <span className="ihub-cell-main">{dia(r.createdAt)}</span>
          <span className="ihub-cell-sub">{hora(r.createdAt)}</span>
        </>
      ),
    },
    {
      key: 'status',
      label: 'Status',
      sortable: true,
      width: 130,
      render: (r: any) => (
        <Badge tone={ok(r) ? 'success' : 'danger'} dot>
          {ok(r) ? 'Processed' : 'Error'}
        </Badge>
      ),
    },
    {
      key: 'message',
      label: 'Message',
      render: (r: any) => (
        <>
          <span className="ihub-cell-main ihub-truncate">{corto(r.message) || '-'}</span>
          {r.entity ? <span className="ihub-cell-sub ihub-truncate">{r.entity}</span> : null}
        </>
      ),
    },
    {
      key: 'identificator',
      label: 'Integration',
      sortable: true,
      width: 190,
      render: (r: any) => (
        <>
          <Badge tone="info">{integracion(r.identificator)}</Badge>
          {r.iTask?.descripcion ? <span className="ihub-cell-sub ihub-truncate" style={{ maxWidth: 190 }}>{r.iTask.descripcion}</span> : null}
        </>
      ),
    },
    {
      key: 'Number',
      label: 'Number',
      sortable: true,
      width: 200,
      render: (r: any) => (
        <span className="ihub-cell-main ihub-truncate" style={{ maxWidth: 200 }}>
          {r.Number || '-'}
        </span>
      ),
    },
    ...(admin
      ? [
          {
            key: 'clientId',
            label: 'Client',
            sortable: true,
            width: 180,
            render: (r: any) => (
              <>
                <span className="ihub-cell-main ihub-truncate" style={{ maxWidth: 180 }}>
                  {r.clientId ? nombreCliente(r.clientId) : '-'}
                </span>
                {r.clientId ? <span className="ihub-cell-sub">#{r.clientId}</span> : null}
              </>
            ),
          },
        ]
      : []),
  ];

  // Exportar: todo lo que cumple los filtros (no solo la página), con el mismo orden de la tabla.
  const exportCols = [
    { label: 'Date', width: 20, value: (r: any) => (fecha(r.createdAt) ? (fecha(r.createdAt) as any).format('YYYY-MM-DD HH:mm:ss') : '') },
    { label: 'Status', width: 12, value: (r: any) => (ok(r) ? 'Processed' : 'Error') },
    { label: 'Message', width: 60, value: (r: any) => r.message },
    { label: 'Integration', width: 18, value: (r: any) => integracion(r.identificator) },
    { label: 'Task', width: 24, value: (r: any) => r.iTask?.descripcion || r.taskId || '' },
    { label: 'Entity', width: 22, value: (r: any) => r.entity },
    { label: 'Number', width: 22, value: (r: any) => r.Number },
    ...(admin ? [{ label: 'Client', width: 20, value: (r: any) => (r.clientId ? `${nombreCliente(r.clientId)} #${r.clientId}` : '') }] : []),
    { label: 'Request', width: 40, pdf: false, value: (r: any) => r.text },
    { label: 'Result', width: 40, pdf: false, value: (r: any) => r.resultXML },
  ];
  const exportarTodo = () =>
    traerTodo((p: number, size: number) => getExchangeControl({ pagination: { sizePerPage: size, page: p }, filters, order }));

  const cargandoStats = stats === null;
  const s = stats || {};
  const bloques = fila
    ? [
        { k: 'text', label: 'Request', v: legible(fila.text) },
        { k: 'resultXML', label: 'Result', v: legible(fila.resultXML) },
      ].filter((x) => x.v)
    : [];

  return (
    <>
      <Page
        theme="brand"
        eyebrow="Integrations"
        title={titulo}
        subtitle="The result of every task and integration in your Hub: what was processed, when, and whether it worked."
        actions={
          <>
            <ExportMenu fileName={`exchange-control_${filters.from}_${filters.to}`} title={titulo} columns={exportCols} fetchAll={exportarTodo} />
            {loading || cargandoStats ? (
              <Button variant="ghost" icon="bx-stop-circle" onClick={detener}>
                Stop
              </Button>
            ) : null}
            <Button variant="secondary" icon="bx-refresh" onClick={() => setRecarga((n) => n + 1)}>
              Refresh
            </Button>
          </>
        }
      >
        <PageTitle>
          <title>
            {titulo} | {getNameClient()}
          </title>
        </PageTitle>

        <div className="ihub-stats">
          <Stat label="Total" icon="bx-transfer" tone="info" value={s.total} loading={cargandoStats} active={!filters.status} onClick={() => poner({ status: '' })} />
          <Stat
            label="Errors"
            icon="bx-error-circle"
            tone="danger"
            value={s.errors}
            loading={cargandoStats}
            active={filters.status === 'Error'}
            onClick={() => poner({ status: 'Error' })}
          />
          <Stat
            label="Processed"
            icon="bx-check-circle"
            tone="success"
            value={s.processed}
            loading={cargandoStats}
            active={filters.status === 'Processed'}
            onClick={() => poner({ status: 'Processed' })}
          />
        </div>

        <Card>
          <div className="ihub-filters ihub-filters--wide">
            <Field label="Reference" className="ihub-filters__search">
              <MultiSelectField
                libre
                placeholder="Search shipments, BLs, bookings, containers or paste any number"
                options={ops('reference')}
                value={filters.reference}
                onChange={(v: string[]) => poner({ reference: v })}
              />
            </Field>
            <Field label="Date range">
              <DateRange from={filters.from} to={filters.to} onChange={(from: string, to: string) => poner({ from, to })} />
            </Field>
            {admin ? (
              <Field label="Client">
                <MultiSelectField placeholder="All clients" options={ops('clientId')} value={filters.clientId} onChange={(v: string[]) => poner({ clientId: v })} />
              </Field>
            ) : null}
            <Field label="Integration">
              <MultiSelectField
                placeholder="All integrations"
                options={ops('identificator').map((o: any) => ({ value: o.value, label: integracion(o.value) }))}
                value={filters.identificator}
                onChange={(v: string[]) => poner({ identificator: v })}
              />
            </Field>
            <Field label="Task">
              <MultiSelectField placeholder="All tasks" options={ops('taskId')} value={filters.taskId} onChange={(v: string[]) => poner({ taskId: v })} />
            </Field>
            <Field label="Entity">
              <MultiSelectField placeholder="All entities" options={ops('entity')} value={filters.entity} onChange={(v: string[]) => poner({ entity: v })} />
            </Field>
            <Field label="Status">
              <Segmented
                options={[
                  { value: '', label: 'All' },
                  { value: 'Error', label: 'Errors' },
                  { value: 'Processed', label: 'Processed' },
                ]}
                value={filters.status}
                onChange={(v: any) => poner({ status: v })}
              />
            </Field>
          </div>
          {sucio ? (
            <div className="ihub-filters__foot">
              <Button variant="ghost" size="sm" icon="bx-reset" onClick={limpiar}>
                Clear filters
              </Button>
            </div>
          ) : null}
        </Card>

        {error ? (
          <Alert tone="danger" title="Couldn't load Exchange Control">
            {error}
          </Alert>
        ) : null}

        <Card flush>
          <DataTable
            columns={columns}
            rows={data.listData}
            total={data.CountItems}
            page={page}
            pageSize={pageSize}
            onPage={setPage}
            onPageSize={(n: number) => {
              setPageSize(n);
              setPage(1);
            }}
            sort={sort}
            onSort={(nuevo: any) => {
              setSort(nuevo);
              setPage(1);
            }}
            onRowClick={abrir}
            loading={loading}
            empty={
              <EmptyState
                icon="bx-transfer"
                title="Nothing in this range"
                text={sucio ? 'Try a wider date range or clear the filters.' : 'Results show up here as soon as your tasks run.'}
              />
            }
          />
        </Card>
      </Page>

      <Drawer
        open={!!fila}
        onClose={cerrar}
        eyebrow={fila ? integracion(fila.identificator) : ''}
        title={fila ? fila.Number || fila.entity || integracion(fila.identificator) : ''}
        badges={
          fila ? (
            <>
              <Badge tone={ok(fila) ? 'success' : 'danger'} dot>
                {ok(fila) ? 'Processed' : 'Error'}
              </Badge>
              {fila.entity ? <Badge>{fila.entity}</Badge> : null}
            </>
          ) : null
        }
      >
        {fila ? (
          <>
            {fila.message ? (
              <Alert tone={ok(fila) ? 'info' : 'danger'} title="Message">
                {fila.message}
              </Alert>
            ) : null}
            <MetaGrid
              items={[
                {
                  label: 'Date',
                  value: (
                    <>
                      {completa(fila.createdAt)}
                      <span className="ihub-cell-sub">{hace(fila.createdAt)}</span>
                    </>
                  ),
                },
                { label: 'Integration', value: integracion(fila.identificator) },
                {
                  label: 'Task',
                  value: (
                    <>
                      {fila.iTask?.descripcion || '-'}
                      {fila.taskId ? <span className="ihub-cell-sub">#{fila.taskId}</span> : null}
                    </>
                  ),
                },
                { label: 'Entity', value: fila.entity || '-' },
                { label: 'Number', value: fila.Number ? <code className="ihub-code">{fila.Number}</code> : '-' },
                ...(admin
                  ? [
                      {
                        label: 'Client',
                        value: fila.clientId ? (
                          <>
                            {nombreCliente(fila.clientId)} <span className="ihub-muted">#{fila.clientId}</span>
                          </>
                        ) : (
                          '-'
                        ),
                      },
                    ]
                  : []),
              ]}
            />
            {historia === null ? (
              <Card>
                <div className="ihub-email__loading">
                  <div className="ihub-skel" style={{ width: '55%' }} />
                  <div className="ihub-skel" style={{ width: '80%' }} />
                </div>
              </Card>
            ) : historia.length ? (
              <Card flush>
                <div className="ihub-block__head">
                  <span>History</span>
                </div>
                <ol style={{ listStyle: 'none', margin: 0, padding: '0 16px 8px' }}>
                  {historia.map((h: any) => (
                    <li key={h.id} style={{ display: 'flex', gap: 14, alignItems: 'flex-start', padding: '10px 0', borderTop: '1px solid #EEEEF8' }}>
                      <span className="ihub-cell-sub" style={{ minWidth: 118, marginTop: 2 }}>
                        {fecha(h.occurredAt) ? (fecha(h.occurredAt) as any).format('MMM D, YYYY HH:mm') : ''}
                      </span>
                      <span style={{ flex: 1, minWidth: 0 }}>
                        <Badge tone={pasoTono(h)} dot>
                          {pasoEtiqueta(h)}
                        </Badge>
                        <span className="ihub-cell-main" style={{ display: 'block', whiteSpace: 'normal', marginTop: 4 }}>
                          {h.message}
                        </span>
                      </span>
                    </li>
                  ))}
                </ol>
              </Card>
            ) : null}
            <div className="ihub-blocks">
              {bloques.map((x) => (
                <Card flush key={x.k}>
                  <div className="ihub-block__head">
                    <span>{x.label}</span>
                    <Button variant="ghost" size="sm" icon={copiado === x.k ? 'bx-check' : 'bx-copy'} onClick={() => copiar(x.k, x.v)}>
                      {copiado === x.k ? 'Copied' : 'Copy'}
                    </Button>
                  </div>
                  <pre className="ihub-pre">{x.v}</pre>
                </Card>
              ))}
              {!bloques.length ? (
                <Card>
                  <EmptyState icon="bx-file-blank" title="No extra data" text="This result only has the message above." />
                </Card>
              ) : null}
            </div>
          </>
        ) : null}
      </Drawer>
    </>
  );
};

export default SummaryImport;
